import * as fb from "../../firebase";
import moment from "moment";
export default {
  state: {
    rooms: [],
    aiResponse: true,
    chatStatus: "",
    selectedRoom: "",
    newMessage: false,
  },
  getters: {
    getRooms: (state) => state.rooms,
    getAIResponse: (state) => state.aiResponse,
    getChatStatus: (state) => state.chatStatus,
    getSelectedRoom: (state) => state.selectedRoom,
    getNewMessage: (state) => state.newMessage,
  },
  mutations: {
    setRooms(state, room) {
      state.rooms.push(room);
    },
    setAIResponse(state, status) {
      state.aiResponse = status;
    },
    setChatStatus(state, status) {
      state.chatStatus = status;
    },
    setSelectedRoom(state, room) {
      state.selectedRoom = room;
    },
    setNewMessage(state, status) {
      state.newMessage = status;
    },
  },
  actions: {
    fetchRooms({ commit, dispatch }) {
      fb.roomCollection.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            console.log("What is the change? ", change.doc.data());
            let data = change.doc.data();
            data["id"] = change.doc.id;
            console.log("ID of the room created:", change.doc.id);

            setTimeout(() => {
              fb.messagesCollection
                .doc(change.doc.id)
                .get()
                .then((response) => {
                  console.log(
                    "Response from message collection: ",
                    response.data()
                  );
                  data["aiResponse"] = response.data().aiResponse;
                  data["joinedBy"] = response.data().joinedBy;
                  data["messages"] = response.data().messages;
                  data["updatedAt"] = response.data().updatedAt;
                  data["chatStatus"] = response.data().chatStatus;
                  data["count"] = 0;
                  if (
                    moment().diff(moment(data.date.toDate()), "minutes") < 60
                  ) {
                    console.log("Within 15 minutes", change.doc.id);
                    dispatch("claimRoomSnapshot", change.doc.id);
                  }
                  commit("setRooms", data);
                  commit("setNewMessage", true);
                });
            }, 1500);
          } else if (change.type === "modified") {
            console.log("What is the change? ", change.doc.data());
          }
        });
      });
    },
    claimRoom({ getters, dispatch }, roomInfo) {
      console.log("Room Information: ", roomInfo);
      fb.messagesCollection.doc(roomInfo.id).update({
        aiResponse: false,
        joinedBy: getters.userProfile.data().name,
      });
      dispatch("updateMessage", {
        roomId: roomInfo.id,
        message: {
          isMe: false,
          text: getters.userProfile.data().name + " joined the chat.",
          date: moment().format("LTS"),
          responder: "notification",
        },
      });
    },
    updateMessage({ getters }, message) {
      fb.messagesCollection.doc(message.roomId).update({
        messages: fb.firebase.firestore.FieldValue.arrayUnion(message.message),
        updatedAt: moment().format("MM/DD/YYYY h:mm:ss A"),
      });
    },
    claimRoomSnapshot({ getters, commit }, roomId) {
      console.log("Room ID: ", roomId);
      fb.messagesCollection.doc(roomId).onSnapshot((snapshot) => {
        console.log("Snapshot: ", snapshot.data());
        let room = getters.getRooms.filter((rm) => rm.id === snapshot.id);
        console.log("Current Room Data: ", room[0]);
        if (room[0].messages.length !== snapshot.data().messages.length) {
          if (room.length > 0) {
            room[0].messages.push(
              snapshot.data().messages[snapshot.data().messages.length - 1]
            );
            if (getters.getSelectedRoom !== room[0].id) {
              room[0].count = room[0].count + 1;
            }
            room[0].updatedAt = snapshot.data().updatedAt;
            commit("setNewMessage", true);
          }
        } else if (room[0].aiResponse !== snapshot.data().aiResponse) {
          room[0].aiResponse = snapshot.data().aiResponse;
          commit("setAIResponse", snapshot.data().aiResponse);
          commit("setChatStatus", snapshot.data().chatStatus);
        } else if (room[0].chatStatus !== snapshot.data().chatStatus) {
          room[0].chatStatus = snapshot.data().chatStatus
          commit("setChatStatus", snapshot.data().chatStatus);
        }
      });
    },
  },
};
